<template>
  <div class="body1">
    <div class="content">
      <img class="img" src="../../assets/franchise-12.png">
      <div>
        <div class="title bold large">Start-up Capital</div>
        <div class="title">Estimated Investment USD-USD<br/>（depending on country)</div>
        <div class="title bold large">Potential Revenue</div>
        <img class="chart" src="../../assets/franchise-13.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}
}
</script>

<style scoped lang="less">
@import "../../assets/style/index";
.body1{
  height: 460px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  position: relative;
  .content{
    .media-content;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    .img{
      width: 637px;
      object-fit: contain;
      height: 357px;
      margin-right: 50px;
    }
    .chart{
      height: 155px;
      width: 125px;
      object-fit: contain;
    }
    .title{
      text-align: left;
      color: #6D43A1;
      font-size: 18px;
      font-family: 'Adobe Heiti Std', Helvetica, Arial, sans-serif;
      line-height: 30px;
    }
    .bold{
      font-weight: bold;
    }
    .large{
      font-size: 30px !important;
      margin-top: 30px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/franchise/e-body4.vue